/* Pull Mania - aggiunta al carrello dalle schede (Luca, 03-04/10/2026).
   È un modulo come i file del tema (import statici): Shopify comprime gli script normali e
   rovinava l'import dinamico ("require is not defined"), così si apriva la pagina del carrello.
   Stesso procedimento di product-form.js: CartLinesUpdateEvent + sezioni del carrello, così
   tendina laterale, numero sull'icona e apertura automatica si aggiornano da soli. */
import { CartLinesUpdateEvent } from '@shopify/events';
import { fetchConfig } from '@theme/utilities';

function carrelloAggiornato() {
  const c = document.querySelector('cart-items-component');
  if (c && typeof c.fetchCartData === 'function') return c.fetchCartData();
  return fetch(Theme.routes.cart_url + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) => r.json());
}

/** Aggiunge al carrello il contenuto del form; restituisce { errore, messaggio }. */
window.pmAggiungi = async function (form) {
  const dati = new FormData(form);
  const qta = Number(dati.get('quantity')) || 1;
  const ids = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  if (ids.length) dati.append('sections', ids.join(','));
  const attesa = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'product',
    lines: [{ merchandiseId: String(dati.get('id')), quantity: qta }],
    promise: attesa.promise,
  }));
  const cfg = fetchConfig('javascript', { body: dati });
  try {
    const risp = await fetch(Theme.routes.cart_add_url, { ...cfg, headers: { ...cfg.headers, Accept: 'text/html' } }).then((r) => r.json());
    const errore = !!risp.status;
    const cart = await carrelloAggiornato();
    const det = { items: cart.items, source: 'product-form-component', sourceId: 'pm-carrello', itemCount: qta, didError: errore };
    if (!errore) det.sections = risp.sections;
    attesa.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: det });
    return { errore, messaggio: risp.description || risp.message || '' };
  } catch (e) {
    attesa.reject(e);
    throw e;
  }
};
